export enum SortingKeysEnum {
    clinicOfficeId = "clinicOfficeId",
    name = "name",
    email = "email",
    city="city",
    brand="brand",
    hcpAmount="hcpAmount",
    entAmount="entAmount",
    patientsAmount="patientsAmount",
    shown="shown",
   
}
